import { createContext } from 'react';
import { validators } from '@glu/validation-react';

export default createContext();

validators.messages = validators.initMessages();